import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";
import { getAllMenuAction, getMenuAction, changeStatusMenuAction, insertUpdateMenuAction, getBusinessByCategory } from "../../actions/webContentsSettingsActions/menuAction";

const INITIAL_STATE = {
    Menu: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    businessByCategory: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedMenu: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateMenuDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    changeStatusMenuDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }
};

const MenuReducer = createSlice({
    name: "Menu",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetMenuDetailsState(state, action) {
            state.selectedMenu = INITIAL_STATE.selectedMenu;
            state.insertUpdateMenuDetails = INITIAL_STATE.insertUpdateMenuDetails;
            state.changeStatusMenuDetails = INITIAL_STATE.changeStatusMenuDetails;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getAllMenuAction.fulfilled, (state, action) => {
            state.Menu.data = action.payload.data;
            state.Menu.apiMsg.status = action.meta.requestStatus;
            state.Menu.apiMsg.message = "success";
        });
        builder.addCase(getAllMenuAction.pending, (state, action) => {
            state.Menu.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllMenuAction.rejected, (state, action) => {
            state.Menu.apiMsg.message = action.error.message;
            state.Menu.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(getBusinessByCategory.fulfilled, (state, action) => {
            state.businessByCategory.data = {
                ...action.payload.data,
                businessCategoryID: action.meta.arg?.filter?.businessCategoryID,
            };
            state.pendingIndex = null;
            state.businessByCategory.apiMsg.status = action.meta.requestStatus;
            state.businessByCategory.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getBusinessByCategory.pending, (state, action) => {
            state.businessByCategory.data = null;
            state.pendingIndex = action.meta.arg.index;
            state.businessByCategory.apiMsg.message = action.meta.requestStatus;;
            state.businessByCategory.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getBusinessByCategory.rejected, (state, action) => {
            state.pendingIndex = null;
            state.businessByCategory.apiMsg.message = action.error.message;
            state.businessByCategory.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getMenuAction.fulfilled, (state, action) => {
            state.selectedMenu.data = action.payload.data;
            state.selectedMenu.apiMsg.status = action.meta.requestStatus;
            state.selectedMenu.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getMenuAction.pending, (state, action) => {
            state.selectedMenu.data = null;
            state.selectedMenu.apiMsg.message = action.meta.requestStatus;;
            state.selectedMenu.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getMenuAction.rejected, (state, action) => {
            state.selectedMenu.apiMsg.message = action.error.message;
            state.selectedMenu.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(
            insertUpdateMenuAction.fulfilled,
            (state, action) => {

                if (action.meta.arg) {
                    const newData = action.meta.arg;
                    const existingRecords = state.Menu.data.records;

                    const index = existingRecords ? existingRecords.findIndex(record => record.menuID === newData.menuID) : -1;

                    if (!newData.menuID) {
                        newData.menuID = action.payload.data.data;
                    }

                    if (index !== -1) {
                        existingRecords[index] = {
                            ...existingRecords[index],
                            ...newData,

                        };
                    }
                    else {

                        // existingRecords.push(newData);
                        // state.Menu.data.totalRecords = state.Menu.data.totalRecords + 1;
                        // if (newData.CheckuserType == Enums.UserType.MasterAdmin || newData.CheckuserType == Enums.UserType.MasterAdminUser) {
                        //     if (newData.businessID == newData.filterBusinessID) {
                        //         existingRecords.push(newData);
                        //         state.Menu.data.totalRecords = state.Menu.data.totalRecords + 1;
                        //     }
                        // } else {
                            existingRecords.push(newData);
                            state.Menu.data.totalRecords = state.Menu.data.totalRecords + 1;
                        // }

                    }
                    state.Menu.data.records = existingRecords;


                    state.insertUpdateMenuDetails.data = {
                        ...newData
                    };
                }

                state.insertUpdateMenuDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateMenuDetails.apiMsg.message = action.payload.message.message;

                toast.success(action.payload.message.message, {
                    position: "bottom-center",
                    toastId: "success"
                });
            }
        );
        builder.addCase(
            insertUpdateMenuAction.pending,
            (state, action) => {
                state.insertUpdateMenuDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateMenuAction.rejected,
            (state, action) => {

                state.insertUpdateMenuDetails.apiMsg.message = action.error.message;
                state.insertUpdateMenuDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: "bottom-center",
                    toastId: "error"
                });
            }
        );


        builder.addCase(changeStatusMenuAction.fulfilled, (state, action) => {
            if (action.meta.arg.StatusType === Enums.ChangeStatus.Delete) {
                const existingRecords = state.Menu.data.records;
                const menuIDToDelete = action.payload.data.Id;
                const updatedRecords = existingRecords.filter(record => record.menuID !== menuIDToDelete);
                state.Menu.data.records = updatedRecords;
                state.Menu.data.totalRecords = state.Menu.data.totalRecords - 1;
            }
            else if (action.meta.arg.StatusType === Enums.ChangeStatus.Active) {
                const newData = action.meta.arg;
                const existingRecords = state.Menu.data.records;

                const index = existingRecords.findIndex(record => record.menuID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: true,
                    };
                }
            }
            else if (action.meta.arg.StatusType === Enums.ChangeStatus.Inactive) {
                const newData = action.meta.arg;
                const existingRecords = state.Menu.data.records;

                const index = existingRecords.findIndex(record => record.menuID === newData.Id);
                if (index !== -1) {
                    existingRecords[index] = {
                        ...existingRecords[index],
                        active: false,
                    };
                }

            }
            state.changeStatusMenuDetails.apiMsg.status = action.meta.requestStatus;
            state.changeStatusMenuDetails.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(changeStatusMenuAction.pending, (state, action) => {
            state.changeStatusMenuDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(changeStatusMenuAction.rejected, (state, action) => {
            state.changeStatusMenuDetails.apiMsg.message = action.error.message;
            state.changeStatusMenuDetails.apiMsg.status = action.meta.requestStatus;
        });
    }
});

export const { RESET, ResetMenuDetailsState } = MenuReducer.actions;
export default MenuReducer.reducer;